function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Icon from './IconBase';

var IconVisibleOffSmallOutline = function IconVisibleOffSmallOutline(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 14 14"
  }, props, {
    width: "14",
    height: "14"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#14x14_visible_off_outline__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.293 3.121a1 1 0 011.414-1.414l9.586 9.586a1 1 0 01-1.414 1.414l-1.203-1.203A7.457 7.457 0 017 12C4.22 12 1.455 10.448.088 7.41a1 1 0 010-.82 7.977 7.977 0 011.965-2.71l-.76-.76zM3.47 5.3l1.536 1.536a2 2 0 002.158 2.158l.902.902A5.542 5.542 0 017 10c-1.895 0-3.804-.982-4.886-3A5.852 5.852 0 013.47 5.299z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.216 2.216A7.466 7.466 0 017 2c2.78 0 5.545 1.552 6.912 4.59a1 1 0 010 .82 8.137 8.137 0 01-1.377 2.125l-1.417-1.417c.286-.329.545-.701.768-1.118C10.805 4.982 8.896 4 7 4L5.216 2.216z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "14x14_visible_off_outline__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h14v14H0z"
  }))));
};

export default IconVisibleOffSmallOutline;